<template>
    <div v-if="site" class="lm-border pa-3">
        <f-title :title="'Vertragskonditionen Wartungskosten' + (showUnit ? ' (' + this.site.fabricNo + ')': '')"  />
        <v-row class="no-frame mt-0 pt-1 pb-1">
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    label        = "Wartungskosten pro Jahr"
                    :value       = "contract.unit ? toMoney(contract.unit.costs) : '---'"
                    filled
                    align-right
                />
            </v-col>
            <v-col class="no-frame pl-2 white">
                <f-read-only-field
                    label  = "Wartungen pro Jahr"
                    :value = "contract.unit ? contract.unit.count : '---'"
                    filled
                    align-right
                />
            </v-col>
        </v-row>
        <v-row class="no-frame mt-0 mb-2" >
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    label        = "Rechnungsbetrag"
                    :value       = "amount"
                    filled
                    align-right
                />
            </v-col>
            <v-col class="no-frame pl-2 pb-2">
                <f-read-only-field
                    label  = "Rechnungen pro Jahr am"
                    :value = "contract.invoicesPerYear"
                    filled
                    align-right
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";
import FTitle         from "@/modules/core/components/utils/FTitle";

export default {
    name: "CContractMntAbstract",

    components: {
        FTitle,
        FReadOnlyField
    },

    props: {
        showUnit: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    computed: {
        site () {
            return this.$store.getters.site;
        },

        contract () {
            return this.site["liftmanagement"]["mntContract"];
        },

        months () {
            return this.$store.getters.month;
        },

        amount () {
            if (!this.contract.invoicesPerYear) {
                return null;
            }

            return this.toMoney(this.contract.unit.costs / this.contract.invoicesPerYear);
        },
    },

    methods: {
        toMoney (number) {
            return Core.format.money (number);
        },
    }
}
</script>

<style scoped>

</style>